// extracted by mini-css-extract-plugin
module.exports = {"container":"i_container__2Ipgi","item":"i_item__27n8K","key":"i_key__2z30C","value":"i_value__3J029"};